import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { AppProvider } from "@/contexts/AppContext";
import AuthPage from "@/pages/AuthPage";
import SharedNotePage from "@/pages/SharedNotePage";
import PublishedNotePage from "@/pages/PublishedNotePage";
import AppLayout from "@/components/AppLayout";
import VaultLockScreen from "@/components/VaultLockScreen";
import { Toaster } from "sonner";

function MainApp() {
  const { user, loading, isVaultLocked } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background" data-testid="loading-screen">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-muted-foreground/30 border-t-foreground rounded-full animate-spin" />
          <span className="text-sm text-muted-foreground font-mono">Loading VaultNotes...</span>
        </div>
      </div>
    );
  }

  if (!user) return <AuthPage />;

  if (isVaultLocked) return <VaultLockScreen />;

  return (
    <AppProvider>
      <AppLayout />
    </AppProvider>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/published/:token" element={<PublishedNotePage />} />
            <Route path="/shared/:token" element={<SharedNotePage />} />
            <Route path="/*" element={<MainApp />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            className: "bg-card border-border text-foreground",
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
